// extracted by mini-css-extract-plugin
export default {"genericButton":"DownloadButton_genericButton__YfeIR","icon":"DownloadButton_icon__9M2mo","baseline":"DownloadButton_baseline__Q482P","buttonText":"DownloadButton_buttonText__edDjX"};